export function mapWindDegrees(data) {
  //map weather degree to 1-8 range
  let d = data.wind.deg + 22.5;
  d > 360 && (d -= 360);
  d = Math.ceil(d / 45);
  d === 0 && (d = 1);
  data.wind.deg = d;
  return data;
}
